export default {
	properties: [
		{
			text: 'Nombre',
			key: 'nombre',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Extencion',
	plural_model_name_spanish: 'Extenciones',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}